import React, { useCallback, useEffect } from 'react'
import { connect } from 'react-redux'
import { Dropdown } from 'util/ui'
import { doChangeTimeframe } from '../../actions'
import { selectTimeframe } from '../../selectors'

import {
  REPORTING_PERIODS as periods,
  shouldResetReportingPeriod,
} from './reportingPeriod'
import styles from './styles.less'

function ReportingPeriodDropdown({
  rawTimeframe,
  timeframe,
  onChange,
  earliestStartDate,
}) {
  const startDate = timeframe.start.format('YYYY-MM-DD')
  useEffect(
    () => {
      if (
        shouldResetReportingPeriod(rawTimeframe, startDate, earliestStartDate)
      ) {
        onChange('previous_7_days')
      }
    },
    [earliestStartDate, onChange, rawTimeframe, startDate]
  )

  const handlePeriodClick = useCallback((event, { value }) => onChange(value), [
    onChange,
  ])
  const selectedPeriod =
    rawTimeframe === 'previous_30_days' ? periods[1] : periods[0]
  return (
    <Dropdown
      inline
      color="black"
      direction="left"
      className={styles.reportingPeriodDropdown}
      text={selectedPeriod.label}
      icon="caret down"
    >
      <Dropdown.Menu>
        {periods.map(period => (
          <Dropdown.Item
            key={period.value}
            text={period.label}
            value={period.value}
            active={period.value === selectedPeriod.value}
            onClick={handlePeriodClick}
          />
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}

const select = state => ({
  rawTimeframe: state.reports.controls.timeframe,
  timeframe: selectTimeframe(state),
})
const perform = { onChange: doChangeTimeframe }

export default connect(select, perform)(ReportingPeriodDropdown)
